import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWisselwoning1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m18 8 10 8v16H8V16z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M16 22h-6v10h6z"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M23.55 20.37V18l-6 4.81 6 4.81v-2.4h10.22v-4.85z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.84 26.05v-1.87H28v1h-5.16v2.95l-4.602-3.68.624-.78z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M29.49 12.32v-2.4l6 4.81-6 4.81v-2.41H19.27v-4.81z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.99 10.94v3.13H21.5v-1h7.49v-2.13z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWisselwoning1);

export default ForwardRef;
